import ServiceBase from "base/baseService"

export default class TipoCalculoImpostoService extends ServiceBase {

    title = "Tipo de cálculo de imposto"
    pluralTitle = "Tipos de cálculo de imposto"
    url = '/cadastro/fiscal/tipocalculoimposto'
    frontUrl = '/cadastro/fiscal/tipocalculoimposto'
    frontUrlList = '/cadastro/fiscal/tipocalculoimpostolist'
    primaryKey = 'codigo_tci'
    ignoredsSchemaConvertions = []

    prepareToFront(data = {}) {
        data.codigo_tci = data?.codigo_tci || ''
        data.descricao_tci = data?.descricao_tci || ''
        return data
    }

    prepareToSave({ data }) {
        if ('meta' in data) delete data.meta
        return data
    }

}
